var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "icon-path arrow-left",
    d: "M0.308333 5.76667C0.25 5.88333 0.25 6.05833 0.308333 6.23333C0.366667 6.29166 0.366667 6.35 0.425 6.40833L5.09167 11.075C5.325 11.3083 5.675 11.3083 5.90833 11.075C6.14167 10.8417 6.14167 10.4917 5.90833 10.2583L2.23333 6.58333L17.1667 6.58333C17.5167 6.58333 17.75 6.35 17.75 6C17.75 5.65 17.5167 5.41667 17.1667 5.41667L2.23333 5.41667L5.90833 1.74167C6.14167 1.50833 6.14167 1.15833 5.90833 0.924999C5.79167 0.808332 5.61667 0.749999 5.5 0.749999C5.38333 0.749999 5.20833 0.808332 5.09167 0.924999L0.425 5.59167C0.366667 5.65 0.308333 5.70833 0.308333 5.76667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c9d414545574164baf4fc8526d2205af.svg";
export { ForwardRef as ReactComponent };